import { render, staticRenderFns } from "./ToDoItem.vue?vue&type=template&id=2cf54228&scoped=true&"
import script from "./ToDoItem.vue?vue&type=script&lang=js&"
export * from "./ToDoItem.vue?vue&type=script&lang=js&"
import style0 from "./ToDoItem.vue?vue&type=style&index=0&id=2cf54228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf54228",
  null
  
)

export default component.exports